// app/javascript/controllers/toggle_controller.js
import { Controller } from "@hotwired/stimulus"

// Toggles the visibility of a target element by toggling a CSS class.
export default class extends Controller {
  static targets = [ "toggleable" ]
  static classes = [ "hidden" ]

  toggle() {
    const hiddenClass = this.hasHiddenClass ? this.hiddenClass : 'd-none';
    this.toggleableTargets.forEach(target => {
        target.classList.toggle(hiddenClass);
    });
  }

  toggleById(event) {
    const id = event.currentTarget.dataset.toggleId || event.params.id;
    if (id) {
      const element = document.getElementById(id);
      if (element) {
         const hiddenClass = this.hasHiddenClass ? this.hiddenClass : 'd-none';
         element.classList.toggle(hiddenClass);
      }
    }
  }
}
